module.exports = __webpack_public_path__ + "static/media/Inter-BlackItalic.158fd1fd.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-BlackItalic.woff2
// module id = 678
// module chunks = 21